import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { AuthProvider } from './hooks/AuthProvider'
import { initTheme } from './theme'
import './index.css'

// Resolves stored choice > OS preference > dark, and keeps following the OS
// until an explicit choice is made. index.html has already set the attribute
// to avoid a flash, so this normally confirms rather than changes it.
initTheme()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        {/* Inside the router: AuthProvider's signOut navigates, and the guards
            that consume it are route elements. Outside QueryClient would be
            wrong too, since /auth/me is fetched directly rather than through it. */}
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
)
